module.exports = __webpack_public_path__ + "img/16d001-19.c0ae64f5.png";